var fails = require('../internals/fails');

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/freezing.js